import { Button, Spinner } from 'flowbite-react';
import React from 'react';
import { LiaLongArrowAltLeftSolid } from 'react-icons/lia';

const MobileBottomButton = ({
	onBack,
	onNext,
	isLoading,
	nextBtnText,
	disableNextButton,
	disablePrevButton,
}: {
	isLoading?: boolean;
	onBack: () => void;
	nextBtnText: React.ReactElement;
	onNext: () => void;
	disableNextButton?: boolean;
	disablePrevButton?: boolean;
}) => {
	return (
		<div className="flex pb-[12px] px-[16px] gap-[16px] w-full pt-[12px]">
			<Button
				onClick={onBack}
				disabled={disablePrevButton}
				className="text-[#1C1C28] rounded-[8px] p-[8px] [&>span]:!p-0"
				color="light"
			>
				<LiaLongArrowAltLeftSolid className="w-[24px] h-[24px]" />
			</Button>
			<Button color="purplePlaced" className="w-full" disabled={disableNextButton} onClick={onNext}>
				{isLoading ? (
					<div className="absolute flex justify-center inset-0 rounded-[inherit] items-center w-full h-full backdrop-blur-md">
						<Spinner className="float-right" />
					</div>
				) : null}
				{nextBtnText}
			</Button>
		</div>
	);
};

export default MobileBottomButton;
